// Widget that renders nothing, used to hide certain fields in the form
export const HiddenWidget = () => null;
